import {  Edit } from "@mui/icons-material";
import { Button, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, InputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  DialogType, FormActions,} from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";
import { FilterForm } from "../../../components/form/filter-form";


const schema = yup.object({
  centro_operacion_select:yup.mixed().required()
  
 }).required();
const schemaModValidator = yup.object({
  descripcion: yup.string().required(),
  valor: yup.number().required(),
  cod_centro_operacion: yup.mixed().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestrosTiposEntrega = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpOoptions,setCentrosOpOptions] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
      await loadRoles();
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadRoles = async()=>{
      const  {data:{value}} = await AxiosInstance.post("maestros-marketplace/get-lista-precios");
      setRoles(value);
    }
    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/listar_tipos_servicios",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };


    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      product.cant_minima_compra = Number(product.cant_minima_compra)
      console.log("prodct",product,cod_prod);
      setProductoSeleccionado(product);
      
     
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
      console.log({productos_asociados:product.productos_asociados});
    }

    const onOpenModalItem = (edit=false)=>{
      console.log({edit});
      if (!edit){
        setProductoSeleccionado({});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
      
      console.log({typeAction,dataForm});
     
      const urlService = 'maestros-marketplace/upsert_tipos_servicios';
         
        let payload =  {...dataForm,cod_centro_operacion:dataForm.cod_centro_operacion.value};

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }


    const onSearchCentroOp = async (value_search, type_enter) => {
 
      if (type_enter && type_enter.length > 3) {
          try {
    
              const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-centros-operacion-filtros", {
                  search_query: type_enter
              });
              console.log({value});
              setCentrosOpOptions(value);
              return value;
          } catch (e) {
              return [];
          }
    
      }
    
    }
    const searchCpAsociado = async (event, newInputValue) => {
      await loadCentrosOp(newInputValue.toLowerCase());
     
    }

    const  setFilterAply = (filtros)=>{
      setFilterSearchPagination(
        {...filterSearchPagination,
        centro_operacion_select:filtros.centro_operacion_select?.value
        }
      )
    
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"descripcion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"valor",
        keyValue:"valor",
        label:"Valor servicio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"centro_operacion",
        keyValue:"centro_operacion",
        label:"Centro de operacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const configModal =  {
      titleModal: "Metodo de entrega",
      buttomsAction: [
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"descripcion",
          keyValue:"descripcion",
          label:"Descripcion",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
          }
        },
        {
          key:"valor",
          keyValue:"valor",
          label:"Costo del servicio",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small",
          }
        },
        {
          key: "cod_centro_operacion",
          keyValue: "cod_centro_operacion",
          label: "Centro de operacion",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            type:"autoComplete",
            name: 'cod_centro_operacion',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCpAsociado,
            options: centrosOp || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
       
      
      ],
      arrayInputs:[]
    } ;


const InputFilters = [
  {
    grid:{
      xs:3,
      md:3,
      sm:3
    },
    InputComponent:AutoCompleteInputWithLabel,
    keyValue:"centro_operacion_select",
    InputComponentProps:{
      label:"centro de operacion",
      fullWidth: true,
      isLoading: false,
      multiple:false,
      size:'small',
  /*     PopperComponent:(props)=><div hidden={!props.open} >
       
         {props.children}
      </div>, */
      onInputChange: onSearchCentroOp,
      options: centrosOpOoptions || [],
      noOptionsText: "Lista vacia",
      getOptionLabel: (option) => option.label,
      isOptionEqualToValue: (option, value) => option.value === value.value,
      filterOptions:(x) => x,
    }
  },
 

  
  ];

    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schemaModValidator}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >
    <Grid item sm={12} xs={12} md={10} >
          <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar bodega por"}
            inputsFilter={InputFilters}
            schemaModValidatorValidator={schema}
            initialValuesFilter={
            {  centro_operacion_select:null,
             
             
             }
            }
            onApplyFilter={setFilterAply}
          />
        </Grid>

        <Grid item sm={12} xs={12} md={12} >
            <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo tipo de entrega</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}